<template>
  <div id="user-appointments">
    <!-- <APPOINTMENTS BY TODAY TOGGLE> -->
    <label class="switch">
      <input
        type="checkbox"
        checked
        @click="appointmentsToggle = !appointmentsToggle; getAppointmentsByUser()"
      >
      <span class="slider round"></span>
    </label>
    <p v-if="appointmentsToggle == true" style="display:inline-block">Održani termini</p>
    <!-- </APPOINTMENTS BY TODAY TOGGLE> -->
    <!-- REPORT CREATE/UPDATE DIALOG -->
    <v-dialog v-model="reportDialog" max-width="790">
      <v-card>
        <v-card-text>
          <img
            @click="reportDialog = false"
            class="close-icon"
            src="../../../assets/icons/close.png"
            alt="Close"
          >
          <report-create
            :dialog="reportDialog"
            :isUpdate="isReportUpdate"
            @refreshData="refreshData"
            @closeDialog="closeDialog"
            :appointmentUsersId="selectedAppointment"
          ></report-create>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container>
      <v-data-table :headers="headers" :items="appointments" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.Date }}</td>
          <td class="text-xs-left">{{ props.item.TimeFrom }}</td>
          <td class="text-xs-left">{{ props.item.TimeTo }}</td>
          <td class="text-xs-left">{{ props.item.AppointmentType }}</td>
          <td class="text-xs-left">{{ props.item.Studio }}</td>
          <td class="text-xs-center">
            <img
              v-if="!props.item.IsReported"
              @click="openReportDialog(props.item.AppointmentUsersId,false)"
              class="action-icon-sm"
              src="../../../assets/icons/report.png"
              alt="Report"
            >
            
            <img
              v-else
              @click="openReportDialog(props.item.AppointmentUsersId,true)"
              class="action-icon-sm"
              src="../../../assets/icons/report-edit.png"
              alt="Report edit"
            >
          </td>
        </template>
      </v-data-table>
    </v-container>
    <!-- <PAGINATION> -->
    <div class="text-xs-center pagination">
      <v-pagination :total-visible="5" @input="getAppointmentsByUser" v-model="selectedPage" :length="numberOfPages"></v-pagination>
    </div>
    <!-- </PAGINATION> -->
  </div>
</template>

<script>
import ReportCreate from "../../Reports/Create";
export default {
  components: {
    reportCreate: ReportCreate
  },
  data() {
    return {
      appointments: [],
      selectedAppointment: null,
      isReportUpdate: false,
      reportDialog: false,
      //Data table headers
      headers: [
        {
          text: "Datum termina",
          value: "datum",
          align: "left"
        },
        {
          text: "Vrijeme od",
          value: "vrijemeOd",
          align: "left"
        },
        {
          text: "Vrijeme do",
          value: "vrijemeDo",
          align: "left"
        },
        {
          text: "Vrsta termina",
          value: "vrstaTermina",
          align: "left"
        },
        {
          text: "Studio",
          value: "studio",
          align: "left"
        },
        {
          text: "Akcije",
          value: "akcije",
          align: "center"
        }
      ],
      //For displaying only past appointmets
      appointmentsToggle: true,
      //Pagination
      numberOfPages: 1,
      selectedPage: 1
    };
  },
  methods: {
    getAppointmentsByUser() {
      //TODO -> Change to logged user
      this.$store.state.services.appointmentService
        .getByUser(localStorage.getItem('user'), this.selectedPage, this.appointmentsToggle)
        .then(result => {
          this.appointments = result.data.Appointments;
          this.numberOfPages = result.data.NumberOfPages;
        })
        .catch(err => {});
    },
    openReportDialog(appointmentUsersId, isUpdate) {
      this.selectedAppointment = appointmentUsersId;
      this.reportDialog = true;
      this.isReportUpdate = isUpdate;
    },
    closeDialog() {
      this.reportDialog = false;
    },
    refreshData() {
      this.closeDialog();
      this.getAppointmentsByUser();
    }
  },
  created() {
    this.getAppointmentsByUser();
  },
  watch: {
    reportDialog() {
      if (this.reportDialog == false) {
        this.isReportUpdate = false;
      }
    }
  }
};
</script>

<style scoped>
#user-appointments {
  padding-bottom: 40px;
}
.pagination {
  position: absolute;
  bottom: 0;
  margin: 30px 0;
  width: 100%;
}
</style>
